import { render, staticRenderFns } from "./ServiceRequestTypesAndSLAConfigurations.vue?vue&type=template&id=205e0738&scoped=true&"
import script from "./ServiceRequestTypesAndSLAConfigurations.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestTypesAndSLAConfigurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205e0738",
  null
  
)

export default component.exports